import React, { useEffect } from 'react'
import styled from 'styled-components';
import { useState, useRef } from 'react';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { HeadingWrap, CommonButton, Span,  BackButtonSpan } from '../../../../Styles/CommonStyles';
import {Autocomplete, TextField} from '@mui/material';
import { Span as OriginalSpan } from '../../../../Styles/CommonStyles';
import { useSelector } from 'react-redux';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import {  useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import JoditEditor from 'jodit-react';
import UnivMyAssetComp from '../../Myasset/UnivMyAssetComp';
import { useGetAssetsFinalQuery, useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';
import {useGetStoreOfficesQuery} from '../../../../features/storeoffices/storeofficesApiSlice';
import { useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';
import { useNavigate } from 'react-router-dom';
import FilteredAssetsFetcher from '../../Myasset/FilteredAssetsFetcher';


const StartAlignedSpan = styled(OriginalSpan)`
  align-items: flex-start;
`;
const Container = styled.div`
  width: 100%;
`
const IndiWrap = styled.div`
  margin-bottom: 20px;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const Wrapper = styled.div`
  width: 100%;
`
const AllWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: space-around;
  flex-grow: 1;
  row-gap: 50px;
  margin-bottom: 20px;
`
const OptionContainer = styled.div`
    width:350px;
    display: flex;
    height:150px;
    background-color:#fff;
    /* align-items: center;
    justify-content: center; */
    color: #58548E;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 1.2857142857142856rem;
    line-height: 1.334;
    letter-spacing: 0em;
    margin-left: 24px;
    font-weight: 700;
    cursor: pointer;
    position: relative;
    transition: box-shadow 0.3s;
    &:hover{
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    }
`
const InnerContainer = styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
`
const OptWrap = styled.div``
const SingleUserWrap = styled.div`
  display: flex;
`
const EmailSelectWrap = styled.div`
  margin-right: 20px;
`
const SingleoffCont = styled.div`
`
const SingleSelectCont = styled.div`
`
const StoreSelect = styled.div`
  margin-left:20px;
`
const MultiUserCont = styled.div`
`
const MultiUserWrap = styled.div`
  display: flex;
`
const UserSelectWrap = styled.div``
const OfficeSelectWrap = styled.div`
  margin-bottom: 20px;
  margin-right: 20px;
`
const TextInputWrap = styled.div`
  margin-bottom:10px;
`
const UploadPdfWrapper = styled.div`
  display: flex;
  align-items:center;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  cursor: pointer;
`
const ViewButton = styled.button`
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-right:5px;
  margin-left: 5px;
  cursor: pointer;  
`
const SelectFileReset = styled.button`
  background-color: transparent;
  color: #999;
  border: none;
  font-size: 35px;
  cursor: pointer;
  padding: 0;
  margin-left:2px;
`
const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:15px;
  margin-top: 30px;
  margin-bottom: 5px;
  font-weight: bold;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 24px;
  font-weight: 900;
  color: #5C5891;  
`
const Issuebutton = styled(CommonButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10vw;
  height: 50px;
  background-color: teal;
  margin-right: 30px;
  cursor: pointer;
  border-radius: 10px; 
`
const AllStoreAssetsTableCont = styled.div`
  margin-top:20px;
`
const SpanContainer = styled.div`
  display: flex;
  margin-top:10px;
  margin-bottom:10px;
  `
const StatusSpan = styled.span`
  font-size:16px;
  font-family:Arial, sans-serif;
  font-weight:bold;
  color:#333;  
`
const getCurrentDateISO = () => {
  const today = new Date();
  return today.toISOString();
}
const columnFilter = [ "OEM/ORG Tag", "OEM/Brand", "Purchase Date", "Warranty Date", "Detail", "Model"]

const AssetSurrender = () => {
  const [byEmailClicked, setByEmailClicked] = useState(false);
  const [byOfficeClicked, setByOfficeClicked] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [selectedUser, setSelectedUser] = useState();
  const [offsingle, setOffsigle] = useState();
  const [selectedOff1, setSelectedOff1] = useState();
  const [selectedUserbyOff, setSelectedUserbyOff] = useState();
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [indiAssets, setIndiAssets] = useState('No');
  const editor = useRef(null);
  const [content, setContent] = useState('');
  const inputPdfFile = useRef(null);
  const [selectedfile, setSelectedFile] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [asstCounter, setAsstCounter] = useState({});
  const [storeoffice, setStoreoffice] = useState();
  const [assetsUpdateBody, setAssetsUpdateBody] = useState();
  const [jsonData, setJsonData] = useState({collection:"transactions", data:{}, type:"addnew", oldPath:""});
  const [allData, setAllData] = useState([]);  
  const [filters, setFilters] = useState({      
      perm_cur_store:[],
      perm_alloc_ofc:[],
      perm_alloc_user:[],
      indi_issue: false
    });
  const navigate = useNavigate();


  const { id, email, designation } = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));


  const { users } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })
  const { offices } = useGetofficesQuery('offices', {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })
  const { assets } = useGetAssetsFinalQuery('assets', {
    selectFromResult: ({ data }) => ({
        assets: data?.entities
    }),
  })
  const {storeoffices} = useGetStoreOfficesQuery('storeoffices', {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });

  // update multiple documents in assets collection
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();

  const [uploadFile] = useUploadFileMutation();

  const folderName = "surrender";

  const backClickedHandler = () => {
    setByEmailClicked(false);
    setByOfficeClicked(false);
    // setIndiAssets("No");
    setEmailId();
    setOffsigle();
    setSelectedUserbyOff();
    setSelectedUser();
    setSelectedOff1();
    setAsstCounter({});
    setSelectedOptions([]);
    setStoreoffice()
    // setSelectedOptions([]);
  }
  //Function to select email while using Select User by Email Option
  const handleEmailSelect = (event, newValue) => {
    setEmailId(newValue);
    if(newValue?.length){
        const tempUser = Object.values(users).find(x => x.email === newValue);
        setSelectedUser(tempUser);
    } else {
        setSelectedUser({})
    }
    setOffsigle();
    setStoreoffice();
    setSelectedOptions([]);
  }
  //Select Office while using Select User by Office Option.
  const handleSelectOffice = (event, newValue) => {
    setSelectedOff1(newValue);
    const tempFilteredUsers = Object.values(users).filter(x => (x.office.mainCharge === newValue || x.office.additionalCharge.includes(newValue)));
    setFilteredUsers(tempFilteredUsers);
    setSelectedUserbyOff();
    setStoreoffice();
    setSelectedOptions([]);
  }
  //Function to select user after choosing office in Select User by Office Option.
  const handleselectedUserbyOff = (event, newValue) => {
    setSelectedUserbyOff(newValue);
    setEmailId(newValue?.value?.email);
    setSelectedOptions([]);
  }
  // handle file upload
  const handlePdfFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        setSelectedFile(file)       
      } else {
        alert('Please select only PDF file.');
        event.target.value = null;
      }
    }
  }
  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };
  const deleteSelectFile = () => {
    if (inputPdfFile.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text";
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
    }
  }
  const handleviewFile = () =>{
    window.open(URL.createObjectURL(selectedfile), '_blank');
  }
  const SurrenderAssets = async () => {
    if(!selectedOptions.length) return alert("Please select at least one asset for surrender");
    if(!selectedfile) return alert("Please upload reference document for direct surrender");
    if(selectedfile){
      const confirmation = window.confirm(`Please verify the uploaded file first as if it get submitted once can not be edited. If you like to continue with current file Press 'Ok' or Press 'cancel' to reselect the file.`);
      if(!confirmation) return alert("Cancelled")
    }

    try {
      //create request (If file is selected, it will be appended else only json data will be added)
      const formData = new FormData();
      if(selectedfile) formData.append('file', selectedfile);
      formData.append('jsonData', JSON.stringify(jsonData));
      await uploadFile({ formData, folder: folderName }).unwrap();

      //update assets by inserting user Id in all issued assets.
      await updateMultipleAssetDocs(assetsUpdateBody)

      navigate('/management/assets/AssetMan')
      return alert('Assets are surrendered')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  useEffect(()=>{
    const userOffice = offsingle? offsingle.value:selectedOff1;
    if(assets && (selectedUser || selectedUserbyOff) && storeoffice){
      if(indiAssets === "Yes"){
        setFilters((prevFilters) => ({
          ...prevFilters,
          perm_cur_store: [storeoffice],
          perm_alloc_ofc: [userOffice],
          perm_alloc_user: selectedUser? [selectedUser.id] : [selectedUserbyOff?.value?.id],
          indi_issue: ["true"]
        }));      
      }
      if(indiAssets === "No"){
        setFilters((prevFilters) => ({
          ...prevFilters,
          perm_cur_store: [storeoffice],
          perm_alloc_ofc: [userOffice],
          perm_alloc_user: selectedUser? [selectedUser.id] : [selectedUserbyOff?.value?.id],
          indi_issue: ["false"]
        }));
      }
    }   
  },[assets, selectedUser, selectedUserbyOff, storeoffice, indiAssets])

  useEffect(()=>{
    if(selectedOptions.length){
      const finalSelectedUser = selectedUserbyOff? selectedUserbyOff.value:selectedUser;
      const userid = finalSelectedUser._id;
      const userOffice = offsingle? offsingle.value:selectedOff1;

    //TransactionData
    const transacData = {
      transac_id:`TRDSR-${Date.now().toString(36)}`,
      req_id:"",
      asset_id: selectedOptions.map(x => x._id),
      transac_type:"directsurrender",
      indi_asset: indiAssets === "Yes"? true : false,
      from_userid: finalSelectedUser?.email,
      from_office: userOffice,
      from_desig: finalSelectedUser.designation[userOffice],
      from_store: user_current_office,
      to_userid: email,
      to_office: user_current_office,
      to_desig: designation[user_current_office],
      to_store: user_current_office,
      pdfPath:"",
      time_stamp: getCurrentDateISO()
    }
 
    setJsonData(prevValue => ({
      ...prevValue, data: transacData 
    }));    

    // assets update object
    setAssetsUpdateBody(
      {
        assetIdArray: selectedOptions.map(x => x.id) || [],
        updates: {
          cur_loc: "store",
          last_trans_date: new Date().toISOString(),
          alloc_user: "",
          alloc_ofc: "Not Applicable",
          indi_issue: false,
          cur_user_name: "User not Defined"
        }
      }
    )    
  }   
  },[selectedOptions]);

  return (
    <Container>
        <FilteredAssetsFetcher filters={filters} onDataFetched={setAllData} />
       {(byEmailClicked || byOfficeClicked) && <BackArrowContainer onClick={backClickedHandler}><ArrowLeftIcon /><BackButtonSpan >Back </BackButtonSpan></BackArrowContainer>}
      <Wrapper>
        <AllWrapper>
          {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByEmailClicked(true)}><InnerContainer>Select User By Email</InnerContainer></OptionContainer>}
          {!byEmailClicked && !byOfficeClicked && <OptionContainer onClick={(e) => setByOfficeClicked(true)}><InnerContainer>Select User By Office </InnerContainer></OptionContainer>}
        </AllWrapper>
        <OptWrap>
          {(byEmailClicked || byOfficeClicked) && <IndiWrap>
            <Autocomplete
              id="combo-box-demo"
              options={['Yes', 'No']}
              sx={{ width: 400 }}
              value={indiAssets}
              onChange={(event, newValue) => {
                  setIndiAssets(newValue);
                  setSelectedOptions([]);
              }}
              renderInput={(params) => <TextField {...params} label="Is the asset to be issued to individual by Name?" />}
            />
            </IndiWrap>}         
          {!byOfficeClicked && byEmailClicked && <><SingleUserWrap>
            <EmailSelectWrap>
              <Autocomplete
                id="combo-box-demo"
                options={users? Object.values(users)?.map(elm => elm.email):[]}
                sx={{ width: 400 }}
                value={emailId}
                onChange={(event, newValue) => handleEmailSelect(event, newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => <TextField {...params} label="Enter user Email Id" />}
              />
            </EmailSelectWrap>
              {emailId && <SingleoffCont>
                <SingleSelectCont>
                  <Autocomplete
                      id="combo-box-demo"
                      options={[{label:`${selectedUser?.office?.mainCharge} (Main Charge)`,value:selectedUser?.office?.mainCharge}].concat(selectedUser.office.additionalCharge.map(x => { return {label:x, value:x}}))}
                      sx={{ width: 400 }}
                      value={offsingle?.label?.length? offsingle.label: null}
                      onChange={(event, newValue) => {
                          setOffsigle(newValue);
                          setStoreoffice();
                          setSelectedOptions([]);
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </SingleSelectCont>                
              </SingleoffCont>}
              {(emailId && offsingle) && <StoreSelect>
                <Autocomplete
                  id="combo-box-demo"
                  options={storeoffices? Object.values(storeoffices).map(x => x.storeoffice):[]}
                  sx={{ width: 400 }}
                  value={storeoffice? storeoffice: null}
                  onChange={(event, newValue) => {
                    setStoreoffice(newValue);
                    setSelectedOptions([]);
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Store Office" />}
                />
              </StoreSelect>}              
            </SingleUserWrap>
            {storeoffice && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUser)}, Designation: ${selectedUser?.designation[offsingle?.value]}`}</StartAlignedSpan>}
            </>}
          </OptWrap>
          <OptWrap>
            <MultiUserCont>
              {byOfficeClicked && !byEmailClicked && <MultiUserWrap>
                <OfficeSelectWrap>
                  <Autocomplete
                    id="combo-box-demo"
                    options={Object.values(offices)?.map(elm => elm.name)}
                    sx={{ width: 400 }}
                    value={selectedOff1 || null}
                    onChange={(event, newValue) => handleSelectOffice(event, newValue)}
                    renderInput={(params) => <TextField {...params} label="Select Office" />}
                  />
                </OfficeSelectWrap>
                {selectedOff1 && <UserSelectWrap>
                  <Autocomplete
                      id="combo-box-demo"
                      options={filteredUsers?.length? filteredUsers.map(x => {return {label:`${x?.email} (${nameStringFn(x)})- ${x?.designation[selectedOff1]}`, value:x} }):[]}
                      sx={{ width: 400 }}
                      value={selectedUserbyOff || null}
                      onChange={(event, newValue) => handleselectedUserbyOff(event, newValue)}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => <TextField {...params} label="Select User" />}
                  />
                  </UserSelectWrap>}
                  {(selectedOff1 && selectedUserbyOff) && <StoreSelect>
                    <Autocomplete
                      id="combo-box-demo"
                      options={storeoffices? Object.values(storeoffices).map(x => x.storeoffice):[]}
                      sx={{ width: 400 }}
                      value={storeoffice? storeoffice: null}
                      onChange={(event, newValue) => {
                        setStoreoffice(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} label="Select Store Office" />}
                    />
                  </StoreSelect>}
                </MultiUserWrap>}
                {selectedUserbyOff && <StartAlignedSpan>{`Name: ${nameStringFn(selectedUserbyOff?.value)}, Designation: ${selectedUserbyOff?.value?.designation[selectedOff1]}`}</StartAlignedSpan>}
            </MultiUserCont>
          </OptWrap>
          {((byOfficeClicked || byEmailClicked) && (((emailId && offsingle)) || (selectedOff1 && selectedUserbyOff )) && storeoffice) ? <div>
            <AllStoreAssetsTableCont>
              <SubHeadingField>
              {allData?.assets?.length? "Select Assets to be surrendered": "No Assets Available for Surrender"}
              </SubHeadingField>
              {allData?.assets?.length?<UnivMyAssetComp filterProps={filters} columnFilter={columnFilter} checkbox={true} selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}  />:null}
            </AllStoreAssetsTableCont>
            {allData?.assets?.length?<><TextInputWrap>
              <HeadingWrap>
                  <Span>Details/Justifications</Span>
              </HeadingWrap>
              <JoditEditor
                  ref={editor}
                  value={content}
                  onBlur={newContent => setContent(newContent)}
                  onChange={newContent => { }}
                  config={{ height: '20vh' }}
              />
            </TextInputWrap>
            <UploadPdfWrapper>
              <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
              <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
              Upload reference document as a single PDF only
              </CustomFileUploadButton>
              {selectedfile  && <><span>{selectedfile?.name}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>}
            </UploadPdfWrapper></>:null}
          </div>:null}
      </Wrapper>
      {selectedOptions?.length ? <SpanContainer>
        <StatusSpan>{`Total Items Selected: ${selectedOptions.length} (${Object.entries(
                selectedOptions.reduce((acc, { name }) => {
                  acc[name] = (acc[name] || 0) + 1;
                  return acc;
                }, {})
              )
                .map(([name, count]) => `${name}: ${count}`)
                .join(', ')})`}</StatusSpan>
      </SpanContainer>:null}
      {((byOfficeClicked || byEmailClicked) && allData?.assets?.length && selectedOptions)? <Issuebutton onClick={SurrenderAssets}>Surrender</Issuebutton>:null}
    </Container>
  )
}

export default AssetSurrender